import { render, staticRenderFns } from "./Admin.vue?vue&type=template&id=c5df393c"
import script from "./Admin.vue?vue&type=script&lang=js"
export * from "./Admin.vue?vue&type=script&lang=js"
import style0 from "./Admin.vue?vue&type=style&index=0&id=c5df393c&prod&lang=scss&soped=true"
import style1 from "./Admin.vue?vue&type=style&index=1&id=c5df393c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports